/**
 * Research Engine — public facade.
 *
 * The single import point for the design-intelligence layer. Every authored
 * knowledge fragment is validated at load so a malformed source or an invalid
 * genome/pattern reference fails fast in development rather than silently
 * corrupting a composed brief.
 *
 * The Thinking Engine consumes a Research Brief; the compiler and editor never
 * see one.
 */

import { allFragments } from './knowledge';
import { validateFragment } from './validateFragment';

allFragments().forEach(({ fragment, label }) => {
  const { valid, errors } = validateFragment(fragment, label);
  if (!valid) throw new Error(`Invalid research fragment [${label}]: ${errors.join('; ')}`);
});

export { composeResearchBrief } from './composeResearchBrief';
export { validateFragment } from './validateFragment';
export { mergeFragments } from './mergeFragments';
export {
  RESEARCH_SCHEMA_ID, RESEARCH_VERSION, RESEARCH_FIELDS, MERGE,
  PROSE_FIELDS, LIST_FIELDS, SOURCE_ORDER, REQUEST_DIMENSIONS,
} from './researchSchema';
